import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Catalog, ExtensionRef, Layer } from './data/catalog';
import { forkJoin, Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { Bounds } from './data/bounds';
import { MappedLayer } from './data/mapped-layer';
import { MetadataService } from './metadata.service';

@Injectable()
export class CatalogService {
  current:Catalog;
  path:string;

  constructor(private _http:HttpClient, private metadata:MetadataService){
  }

  load(catalogJSON:any){
    this.current = new Catalog(catalogJSON);

    this.current.allLayers().filter(l=>l.options.smallExtent).forEach(l=>{
      l.spatialExtent = this.findExtentOfLayer(l)
    });
  }

  loadFrom(path:string):Observable<Catalog>{
    this.path = path;
    return this._http.get(path).pipe(
      tap(json=>this.load(json)),
      map(_=>this.current));

    //   var result = new Promise<Catalog>((res,rej)=>{
    //     this._http.get(path).subscribe(json=>{
    //       this.load(json);
    //       res(this.current);
    //     });
    //   });

    // return from(result);
  }

  findExtentOfLayer(l: Layer):Observable<Bounds>{
    const tmp = new MappedLayer();
    tmp.layer = l;
    tmp.update();
    return this.metadata.getSpatialExtent(tmp);
  }

  expandLayerExtensions(l: Layer):Observable<Layer>{
    const extensionPath = this.current.extensions;
    if(!extensionPath||!l.publications?.length){
      return of(l);
    }


    const allPubs$ = l.publications.map(pub=>{
      const extension = (pub.options?.tags?.time as ExtensionRef)?.$extension
      if(!extension){
        return of(null);
      }
      const basePath = this.path.split('/').slice(0,-1).join('/');
      const url = `${basePath}/${extensionPath}/${extension}`;
      return this._http.get(url).pipe(
        tap((ext:any)=>{
          pub.options.tags.time = ext;
        }));
    });

    return forkJoin(allPubs$).pipe(
      map(_=>l));
  }
}
